import Dropdown from 'bootstrap/js/dist/dropdown';
import LoadMore from '../components/load-more';

export default {
    init() {
    },
    finalize() {
        new LoadMore();
    }
};
